module.exports = __webpack_public_path__ + "img/wash_pres.4be6b582.png";